import { Farecard } from '../services/types/apitypes';
import { apiGetFareCards } from '../services/api';
import {storageGetCards, storageSetCards} from './storage';

const selectCard = (
  cardId: string,
  cards: Farecard[] | undefined,
  setCards: (f: Farecard[] | undefined) => void,
  setSelectedCard: (f: Farecard | undefined) => void,
) => {
  if (cards && cards.length) {
    setSelectedCard(cards.find((f: Farecard) => f.cardId == cardId));
  } else {
    setSelectedCard(undefined);
  }
  setCards(cards);
};

export async function cardsLoadAndSelect(
  cardId: string,
  setCards: (f: Farecard[] | undefined) => void,
  setSelectedCard: (f: Farecard | undefined) => void,
  auth: any,
) {
  selectCard(cardId, storageGetCards(), setCards, setSelectedCard);
  await apiGetFareCards(auth).then((response) => {
    storageSetCards(response.data);
    selectCard(cardId, response.data, setCards, setSelectedCard);
  });
}

export function cardsAllowCreateVirtual(cards: Farecard[] | undefined) {
  if (!cards) {
    return false;
  }
  return !cards.some((c: Farecard) => c.isVirtualCard);
}

export function cardsIsVisbleCard(card: Farecard) {
  // we are hiding the empty virtual cards.
  return card.cardId;
}
